import { render, staticRenderFns } from "./RbShopDebug.vue?vue&type=template&id=374aaff5&"
import script from "./RbShopDebug.vue?vue&type=script&lang=js&"
export * from "./RbShopDebug.vue?vue&type=script&lang=js&"
import style0 from "./RbShopDebug.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports